var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.section.element,{ref:"sectionElement",tag:"component",domProps:{"node":_vm.node}})
}
var staticRenderFns = []

export { render, staticRenderFns }